import React from "react";
import {executeQuery} from "../../requests/executeQuery";
import filter from "../../filter";
import {getData} from "../../requests/CRUD";
import {formatPropertyName, sortArray} from "../../utils";
import Icon from "../Icon";
import svgSort from '../../svgs/sort.svg';
import svgSortAsc from '../../svgs/sort-asc.svg';
import svgSortDesc from '../../svgs/sort-desc.svg';
import {PROPERTIES} from "../../consts/tables";

const cloneDeep = require('lodash.clonedeep');
const findIndex = require('lodash.findindex');

export default class PropertyStatistics extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            columns: [{
                label: 'Type',
                key: 'TYPE',
                sort: 'default',
            }, {
                label: 'First Name',
                key: 'FIRST_NAME',
            }, {
                label: 'Last Name',
                key: 'LAST_NAME',
            }, {
                label: 'Company',
                key: 'COMPANY_NAME',
            }, {
                label: 'Phone',
                key: 'PHONE',
            }, {
                label: 'Email',
                key: 'EMAIL',
            }, {
                label: 'Downloads',
                key: 'DOWNLOADS',
                style: 'center',
                sort: 'default',
            }],
            data: [],
            original: [],
            loading: true,
            propertyInfo: null,
        };

        this.sortTable = this.sortTable.bind(this);
    }

    componentDidMount() {
        this.fetch(this.props.params.id);
    }

    fetch(id) {
        this.setState({loading: true});
        const options = filter({PROPERTY_ID: id}, 'statistics');
        const propertyOptions = {
            limit: {
                count: 1,
                offset: 0,
            },
            column: [
                'NAME',
                'CITY',
                'STATE',
            ],
            filter: [{
                code: 'ARCIMEDES_ROW_ID',
                text: id,
                type: 'exact',
            }],
        };

        Promise.all([
            getData({tableCode: PROPERTIES, options: propertyOptions}),
            executeQuery({queryName: 'PROPERTY_WEBSITE_USERS', options}),
        ]).then(res => {
            if (res && res[0] && res[0].success && Array.isArray(res[0].data) &&
                res[1] && res[1].success && Array.isArray(res[1].data)) {
                const property = res[0].data[0];
                const propertyName = property && property.NAME ? property.NAME : '';
                const propertyCity = property && property.CITY ? property.CITY : '';
                const propertyState = property && property.STATE ? property.STATE : '';
                const propertyInfo = formatPropertyName(propertyName, propertyCity, propertyState);
                const columns = this.state.columns;
                let data = PropertyStatistics.buildTable(columns, res[1].data, id);
                this.setState({
                    data,
                    original: cloneDeep(data),
                    propertyInfo,
                });
            }
            this.setState({loading: false});
        });
    }

    sortTable(key) {
        let {data, columns} = {...this.state};
        const index = findIndex(columns, {key});

        if (columns[index] && columns[index].sort) {
            // old direction = 'default' (desc by ARC_ROW_ID) => new direction = 'asc'
            // old direction = 'asc' => new direction = 'desc'
            // old direction = 'desc' => new direction = 'default'
            columns[index].sort = columns[index].sort === 'asc' ? 'desc' : (columns[index].sort === 'desc' ? 'default' : 'asc');
            if (columns[index].sort === 'default') {
                data = this.state.original;
            } else {
                const isDesc = columns[index].sort !== 'asc';
                data = sortArray(this.state.original, key, isDesc);
                columns.map((column, colIndex) => {
                    if(column.sort && column.sort !== 'default' && index !== colIndex) {
                        column.sort = 'default';
                    }
                });
            }
        }

        this.setState({data, columns});
    }

    static buildTable(columns, res, id) {
        const data = [];
        res.map((row, index) => {
            data[index] = {};
            columns.map(column => {
                if (column.key === 'TYPE') {
                    data[index][column.key] = row.IS_PRINCIPAL === 'y' ? 'Principal' : row.IS_BROKER === 'y' ? 'Broker' : '';
                    return;
                }
                if (column.key === 'DOWNLOADS') {
                    if (row.PACKAGES_ID) {
                        const packageIds = row.PACKAGES_ID.split(',');
                        data[index][column.key] = packageIds.reduce((accumulator, currentValue) => accumulator + (currentValue === id ? 1 : 0), 0);
                    } else {
                        data[index][column.key] = '';
                    }
                    return;
                }
                data[index][column.key] = row[column.key];
            });
        });
        return data;
    }

    renderTable(columns, data, loading) {
        const message = loading ? 'Loading data...' : 'No data available';
        return (
            <React.Fragment>
                {
                    data.length ?
                        <table className='table'>
                            <thead>
                            <tr>
                                {
                                    columns.map((col, index) => {
                                        return (
                                            <th className={`th head border_top ${index === 0 ? 'border_left' : ''}`}
                                                key={col.key}>
                                                {
                                                    col.sort ?
                                                        <React.Fragment>
                                                            {col.label}
                                                            <div className={`sort-icon ${col.sort !== 'default' ? 'active' : ''}`}
                                                                 onClick={() => this.sortTable(col.key)}>
                                                                <Icon svg={col.sort === 'asc' ? svgSortAsc : col.sort === 'desc' ? svgSortDesc : svgSort}/>
                                                            </div>
                                                        </React.Fragment>
                                                        :
                                                        col.label
                                                }
                                            </th>
                                        )
                                    })
                                }
                            </tr>
                            </thead>
                            <tbody>
                            {
                                data.map((row, index) => {
                                    return (
                                        <tr key={index}>
                                            {
                                                columns.map((col, colIndex) => {
                                                    return (
                                                        <td className={`td ${colIndex === 0 ? 'border_left' : ''}`}
                                                            key={`${index}-${colIndex}`}
                                                            style={{textAlign: col.style ? col.style : ''}}>
                                                            {
                                                                col.key === 'EMAIL' ?
                                                                    <a href={`mailto:${row[col.key] ? row[col.key] : ''}`}>{row[col.key]}</a>
                                                                    :
                                                                    row[col.key]
                                                            }
                                                        </td>
                                                    )
                                                })
                                            }
                                        </tr>
                                    )
                                })
                            }
                            </tbody>
                        </table>
                        :
                        <div className='no-data-found'>{message}</div>
                }
            </React.Fragment>
        )
    }

    render() {
        const {columns, data, loading, propertyInfo} = this.state;

        return (
            <div className='property-statistics-container'>
                <h4 className='property-info'>{propertyInfo}</h4>
                {this.renderTable(columns, data, loading)}
            </div>
        )
    }
}